import type { TOC } from '@ember/component/template-only';
import HotelStrategySubtypeIcon from 'lumen/components/hotel/strategy/subtype-icon';

interface HotelStrategySubtypeHeaderSignature {
  Args: {
    formattedLabel: unknown;
    isBranddotcomMemberRatesSubType: unknown;
    isMealtypeType: unknown;
    isMemberRatesType: unknown;
    isMobileBookingSubtype: unknown;
    isMobileExpediaSubtype: unknown;
    isMobileHotelsDotComSubtype: unknown;
    isPosBookingSubtype: unknown;
    isPosExpediaSubtype: unknown;
    label: unknown;
  };
}

const HotelStrategySubtypeHeader = <template>
  {{! @glint-nocheck: not typesafe yet }}
  {{#if @isMemberRatesType}}
    <HotelStrategySubtypeIcon
      @isBranddotcomMemberRatesSubType={{@isBranddotcomMemberRatesSubType}}
      @isMealtypeType={{@isMealtypeType}}
      @isMemberRatesType={{@isMemberRatesType}}
      @isMobileBookingSubtype={{@isMobileBookingSubtype}}
      @isMobileExpediaSubtype={{@isMobileExpediaSubtype}}
      @isMobileHotelsDotComSubtype={{@isMobileHotelsDotComSubtype}}
      @isPosBookingSubtype={{@isPosBookingSubtype}}
      @isPosExpediaSubtype={{@isPosExpediaSubtype}}
      @label={{@label}}
    />
  {{else}}
    <div class="flex items-center justify-center gap-200 truncate">
      <HotelStrategySubtypeIcon
        @isBranddotcomMemberRatesSubType={{@isBranddotcomMemberRatesSubType}}
        @isMealtypeType={{@isMealtypeType}}
        @isMemberRatesType={{@isMemberRatesType}}
        @isMobileBookingSubtype={{@isMobileBookingSubtype}}
        @isMobileExpediaSubtype={{@isMobileExpediaSubtype}}
        @isMobileHotelsDotComSubtype={{@isMobileHotelsDotComSubtype}}
        @isPosBookingSubtype={{@isPosBookingSubtype}}
        @isPosExpediaSubtype={{@isPosExpediaSubtype}}
        @label={{@label}}
      />
      <p class="truncate">{{@formattedLabel}}</p>
    </div>
  {{/if}}
</template> satisfies TOC<HotelStrategySubtypeHeaderSignature>;

export default HotelStrategySubtypeHeader;
